import type { RouteLocationNormalized, Router } from "vue-router";

export const terminationSettingRouteName = {
  index: "terminationSettings.index",
  show: "terminationSettings.show",
};

export const terminationSettingRoute = [
  {
    path: "/termination-settings",
    name: terminationSettingRouteName.index,
    component: () => import("../pages/DataTablePage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "termination_setting",
      breadcrumbs: () => [{ title: "Termination Setting" }],
    },
  },
  {
    path: "/termination-settings/:id",
    name: terminationSettingRouteName.show,
    component: () => import("../pages/DetailPage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "termination_setting",
      breadcrumbs: (_to: RouteLocationNormalized, router: Router) => [{ path: router.resolve({ name: terminationSettingRouteName.index }).path, title: "Termination Setting" }, { title: "Detail" }],
    },
  },
];
